/*
 * Where Connectors lives.
 *
 *   /connectors                                   the attorney's connected apps
 *   /connectors?connected=<slug>&status=success   landing after a Connect Link
 *
 * The Connect Link's callback brings the user back here so the page can
 * confirm the new connection and refresh. No React or IO so it stays
 * unit-testable.
 */
export const CONNECTORS_PATH = "/connectors";

export const connectorsCallbackUrl = (origin: string, slug: string): string =>
  `${origin.replace(
    /\/+$/,
    ""
  )}${CONNECTORS_PATH}?connected=${encodeURIComponent(slug)}`;
